import {style} from 'typestyle'
export const loginPageContainer = style({
    width:"100%",
    height:"97vh",
    display:"flex",
    flexDirection:"column",
    justifyContent:"center",
    alignItems:"center"
})